import { ReactNode } from "react";
import { Col, Row } from "react-bootstrap";
import styles from "./styles.module.scss";
import { Btn } from "../Btn";

interface ILayoutFilter {
  children: any;
  title: string;
  onClickAdd?: () => void;
  actions?: ReactNode;
}

export default function LayoutNotFilter({
  children,
  title,
  onClickAdd,
  actions,
}: ILayoutFilter) {
  return (
    <div className={styles.container}>
      <Row className="mb-1">
        <Col className={styles.titleGroup}>
          <h3>{title}</h3>
          <div className={styles.btnGourp}>
            {actions}
            {onClickAdd && (
              <Btn
                text="Adicionar"
                type="button"
                variante="primary"
                icon="plus"
                onClick={onClickAdd}
              />
            )}
          </div>
        </Col>
      </Row>
      {children}
    </div>
  );
}
